export enum IntegrationType {
  NONE = 'NONE',
  I_BROKER = 'I_BROKER',
  I_BROKER_V2 = 'I_BROKER_V2',
}

export enum TelematicsType {
  NONE = 'NONE',
  S3PWEB = 'S3PWEB',
  NICPLACE = 'NICPLACE',
  MACRO_POINT = 'MACRO_POINT',
  DUMMY = 'DUMMY',
}

export interface CarrierData {
  cid: string
  customerIdentifier: string
  name: string
  integration: IntegrationType
  telematics: TelematicsType
  telematicsCredentials?: string
  recommendedRoutes: boolean
  automaticWaypointUpdatesAllowed: boolean
}

export interface EditCarrierFormValues {
  customerIdentifier: string
  name: string
  integration: IntegrationType
  telematics: TelematicsType
  telematicsCredentials?: string
  recommendedRoutes: boolean
  automaticWaypointUpdatesAllowed: boolean
}
